import script from "./SpeedControl.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeedControl.vue?vue&type=script&setup=true&lang=js"

import "./SpeedControl.vue?vue&type=style&index=0&id=303f00c4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-303f00c4"]])

export default __exports__